import { useEffect, useState, useRef } from 'react';
import { LoginButton } from '../../components/LoginButton/LoginButton';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import evScannerIcon from '../../assets/images/ev_scanner_icon.svg';
import arbitrageIcon from '../../assets/images/arbitrage_icon2.svg';
import outliersIcon from '../../assets/images/outliers_icon.svg';
import screenerIcon from '../../assets/images/sportsbook_screener_icon.svg';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import communityIcon from '../../assets/images/discord_community_icon.svg';
import learnIcon from '../../assets/images/learn_icon.svg';
import toolsIcon from '../../assets/images/tools_icon.svg';
// import wagerwizlogonew from '../../assets/wagerwizlogomarch.svg';
import wagerwizName from '../../assets/WagerWiz_OnDark_Vector.svg';
import emptyUser from '../../assets/images/empty_user.svg';
import { LogoutButton } from '../LogoutButton/LogoutButton';
import { useAuth0 } from '@auth0/auth0-react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Tooltip, IconButton as MUIIconButton } from '@mui/material';
import { Modal } from '@mui/material';
import editicon from '../../assets/images/edit_icon.svg';
import youtubeicon from '../../assets/images/youtube_icon.svg';
import discordicongrey from '../../assets/images/discord_icon_grey.svg';
import settingsicon from '../../assets/images/settings_icon_grey.svg';
import logouticon from '../../assets/images/logout_icon.svg';
import axios from 'axios';
import { saveBankroll } from '../../utils/api/saveBankroll';
import CloseIcon from '@mui/icons-material/Close';

export const SidebarMobile = (props) => {
	const { isAuthenticated, user, logout } = useAuth0();
	const { openOverride, setOpenOverride, bankroll, setBankroll, profilepic, profilename, paymentLink } = props;
	const [openInternal, setOpenInternal] = useState(false);
	const open = typeof openOverride === 'boolean' ? openOverride : openInternal;
	const setOpen = setOpenOverride || setOpenInternal;

	const [showAccountSettings, setShowAccountSettings] = useState(false);
	const [bankrollEditable, setBankrollEditable] = useState(false);
	const bankrollbuttonref = useRef('bankroll');
	const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
	const [isAccountLoading, setIsAccountLoading] = useState(false);

	const userdb = window.localStorage.getItem('userdb') !== 'undefined' ? JSON.parse(window.localStorage.getItem('userdb')) : null;

	const [plan, setPlan] = useState('Free');
	// Initialize bankrollValue from bankroll prop, userdb, or default
	const getInitialBankroll = () => {
		if (bankroll !== undefined && bankroll !== null && bankroll !== '') {
			return bankroll;
		}
		const currentUserdb = window.localStorage.getItem('userdb') !== 'undefined' ? JSON.parse(window.localStorage.getItem('userdb')) : null;
		return currentUserdb?.user_data?.[0]?.bankroll || 10000;
	};
	const [bankrollValue, setBankrollValue] = useState(getInitialBankroll());
	const bankrollSaveTimeoutRef = useRef(null);
	
	// Sync bankrollValue with bankroll prop if available
	useEffect(() => {
		if (bankroll !== undefined && bankroll !== null && bankroll !== '') {
			setBankrollValue(bankroll);
		}
	}, [bankroll]);
	
	// When showAccountSettings becomes true, ensure bankrollValue is set to the current saved bankroll
	useEffect(() => {
		if (showAccountSettings) {
			// Get the most current bankroll value from prop, then userdb
			let currentBankroll;
			if (bankroll !== undefined && bankroll !== null && bankroll !== '') {
				currentBankroll = bankroll;
			} else {
				// Read fresh from localStorage to get the latest value
				const currentUserdb = window.localStorage.getItem('userdb') !== 'undefined' ? JSON.parse(window.localStorage.getItem('userdb')) : null;
				const savedBankroll = currentUserdb?.user_data?.[0]?.bankroll;
				// Use saved bankroll if it exists and is valid, otherwise keep current bankrollValue
				if (savedBankroll !== undefined && savedBankroll !== null && savedBankroll !== '') {
					currentBankroll = savedBankroll;
				} else {
					// Keep current bankrollValue if no valid saved value found
					return;
				}
			}
			setBankrollValue(currentBankroll);
		}
	}, [showAccountSettings, bankroll]);
	
	// Function to save bankroll with debouncing
	const saveBankrollDebounced = (value, userEmail) => {
		// Clear any existing timeout
		if (bankrollSaveTimeoutRef.current) {
			clearTimeout(bankrollSaveTimeoutRef.current);
		}
		
		// Set new timeout
		bankrollSaveTimeoutRef.current = setTimeout(async () => {
			if (!value || value === '' || isNaN(parseFloat(value))) {
				return;
			}
			
			const currentUserdb = JSON.parse(window.localStorage.getItem('userdb'));
			const email = userEmail || currentUserdb?.email;
			
			if (!email) {
				console.log('No email available for bankroll save');
				return;
			}
			
			try {
				const copy = JSON.parse(window.localStorage.getItem('userdb'));
				if (copy?.user_data) {
					for (const c of copy.user_data) {
						c.bankroll = value;
					}
					window.localStorage.setItem('userdb', JSON.stringify(copy));
				}
				await saveBankroll(value, email);
				console.log('Bankroll saved:', value, 'for email:', email);
			} catch (e) {
				console.error('Error saving bankroll:', e);
			}
		}, 500);
	};
	
	// Format number with commas
	const formatNumber = (num) => {
		if (!num && num !== 0) return '';
		const numStr = String(num);
		// Handle decimal numbers
		if (numStr.includes('.')) {
			const [integer, decimal] = numStr.split('.');
			return integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + decimal;
		}
		return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};

	// Set plan from userdb
	useEffect(() => {
		if (userdb?.stripe_plan) {
			if (userdb.stripe_plan?.nickname?.includes('Apprentice') && userdb?.stripe_status !== 'deleted' && userdb.stripe_status !== 'past_due') {
				setPlan('🔨 Apprentice');
			} else if (userdb.stripe_plan?.nickname?.includes('Visionary') && userdb?.stripe_status !== 'deleted' && userdb.stripe_status !== 'past_due') {
				setPlan('🪄 Visionary');
			} else if (userdb.stripe_plan?.nickname?.includes('Oracle') && userdb?.stripe_status !== 'deleted' && userdb.stripe_status !== 'past_due') {
				setPlan('🔮 Oracle');
			} else {
				setPlan('Free');
			}
		}
	}, [userdb?.stripe_plan, userdb?.stripe_status]);

	// Focus input when entering edit mode
	useEffect(() => {
		if (bankrollEditable && bankrollbuttonref.current) {
			// Use setTimeout to ensure the input is rendered before focusing
			const timer = setTimeout(() => {
				if (bankrollbuttonref.current) {
					bankrollbuttonref.current.focus();
				}
			}, 10);
			return () => clearTimeout(timer);
		}
	}, [bankrollEditable]);

	// Cleanup timeout on unmount
	useEffect(() => {
		return () => {
			if (bankrollSaveTimeoutRef.current) {
				clearTimeout(bankrollSaveTimeoutRef.current);
			}
		};
	}, []);

	const toggleDrawer = (state) => () => {
		setOpen(state);
	};

	async function handleAccountSettingsClick() {
		if (!userdb?.email) return;
		setIsAccountLoading(true);
		try {
			const access_token = window.localStorage.getItem('access_token');
			const res = await axios.post(
				`${process.env.REACT_APP_BACKEND_URL}/create_customer_portal_session?email=${userdb.email}`,
				{ email: userdb.email },
				{
					headers: {
						Authorization: `Bearer ${access_token}`,
					},
				}
			);
			window.open(res.data.url, '_blank');
		} catch (e) {
			console.error(e);
		} finally {
			setIsAccountLoading(false);
		}
	}

	return (
		<>
			<Drawer
				sx={{ '& .MuiPaper-root': { width: 320, backgroundColor: '#17191e', color: 'white', borderTopLeftRadius: 16, borderBottomLeftRadius: 16 } }}
				anchor="left"
				open={open}
				onClose={toggleDrawer(false)}>
				<Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', position: 'relative' }} role="presentation">
					<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', py: 3, pl: 3, gap: 1 }}>
						{/* <img src={wagerwizlogonew} alt="WagerWiz logo" style={{ height: 32, width: 32, marginLeft: 0 }} /> */}
						<img src={wagerwizName} alt="WagerWiz" style={{ height: 28, marginLeft: 8 }} />
					</Box>
					<Divider sx={{ background: '#23262f', mb: 1 }} />
					{!showAccountSettings ? (
						<>
							<List sx={{ flex: 1 }}>
								<ListItem button onClick={() => (window.location.href = '/')}> <ListItemIcon><img src={evScannerIcon} alt="EV Scanner" width={24} /></ListItemIcon> <ListItemText primary="EV Scanner" /> </ListItem>
								<ListItem button onClick={() => (window.location.href = '/arbitrage')}> <ListItemIcon><img src={arbitrageIcon} alt="Arbitrage" width={24} /></ListItemIcon> <ListItemText primary="Arbitrage" /> </ListItem>
								<ListItem button onClick={() => (window.location.href = '/outliers')}> <ListItemIcon><img src={outliersIcon} alt="Outliers" width={24} /></ListItemIcon> <ListItemText primary="Outliers" /> </ListItem>
								<ListItem button onClick={() => (window.location.href = '/screener')}> <ListItemIcon><img src={screenerIcon} alt="Screener" width={24} /></ListItemIcon> <ListItemText primary="Sportsbook Screener" /> </ListItem>
								<ListItem button onClick={() => (window.location.href = '/pricing')}> <ListItemIcon><AttachMoneyIcon sx={{ color: '#b1b6c3' }} /> </ListItemIcon> <ListItemText primary="Pricing" /> </ListItem>
							<ListItem button onClick={() => window.open('https://t.co/Z41E3czDHW')}> <ListItemIcon><img src={communityIcon} alt="Community" width={24} /></ListItemIcon> <ListItemText primary="Community" /> </ListItem>
							<ListItem button onClick={() => (window.location.href = '/tools')}> <ListItemIcon><img src={toolsIcon} alt="Tools" width={24} /></ListItemIcon> <ListItemText primary="Tools" /> </ListItem>
							<ListItem button onClick={() => (window.location.href = '/blog')}> <ListItemIcon><img src={learnIcon} alt="Blog" width={24} /></ListItemIcon> <ListItemText primary="Blog" /> </ListItem>
							</List>
							<Divider sx={{ background: '#23262f', mt: 1, mb: 2 }} />
							<Box sx={{ px: 2, pb: 3, pt: 1 }}>
								{isAuthenticated && userdb ? (
									<Button variant="outlined" color="inherit" size="small" fullWidth sx={{ borderColor: '#363844', color: '#b1b6c3', textTransform: 'none', mt: 1 }} onClick={() => setShowAccountSettings(true)}>
										Account Settings
									</Button>
								) : (
									<LoginButton />
								)}
							</Box>
						</>
					) : (
						<Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', px: 2, pt: 2 }}>
							<MUIIconButton onClick={() => setShowAccountSettings(false)} sx={{ alignSelf: 'flex-start', mb: 2, color: 'white' }}>
								<ArrowBackIcon />
							</MUIIconButton>
							<Box className="flex flex-row" sx={{ alignItems: 'center', mb: 2 }}>
								<Avatar src={userdb?.picture || emptyUser} alt={userdb?.name || 'User'} sx={{ width: 40, height: 40, bgcolor: '#23262f', mr: 2 }} />
								<Box sx={{ 
									color: '#f0f2f8', 
									flex: 1,
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
									wordBreak: 'break-all',
									alignContent: 'center',
									fontSize: {
										xs: '1rem',  // 16px
										sm: '1.25rem' // 20px
									},
									display: 'flex',
									alignItems: 'center'
								}}>{userdb?.name}</Box>
							</Box>
							<Box sx={{ color: 'white', fontSize: 16, fontWeight: 600, mb: 2, textAlign: 'center' }}>
								{plan}
							</Box>
							<Box sx={{ color: '#b1b6c3', fontSize: '12px', mb: 1 }}>
								Bankroll
							</Box>
							{!bankrollEditable ? (
								<Box
									sx={{
										display: 'flex',
										alignItems: 'center',
										gap: '8px',
										padding: '8px 12px',
										borderRadius: '8px',
										backgroundColor: '#22262e',
										cursor: 'pointer',
										transition: 'background-color 0.2s',
										width: 'fit-content',
										minWidth: '150px',
										mb: 2,
										'&:hover': {
											backgroundColor: '#2a2e36',
										},
									}}
									onClick={() => {
										setBankrollEditable(true);
									}}>
									<Box component="span" sx={{ color: 'white', fontSize: '20px', fontWeight: 600 }}>
										${formatNumber(bankrollValue)}
									</Box>
								</Box>
							) : (
								<Box
									sx={{
										display: 'flex',
										alignItems: 'center',
										gap: '8px',
										padding: '8px 12px',
										borderRadius: '8px',
										backgroundColor: '#22262e',
										width: 'fit-content',
										minWidth: '150px',
										mb: 2,
									}}>
									<Box component="span" sx={{ color: 'white', fontSize: '20px', fontWeight: 600 }}>
										$
									</Box>
									<input
										type="text"
										inputMode="numeric"
										className="bankroll-input"
										style={{
											border: 'none',
											outline: 'none',
											backgroundColor: 'transparent',
											color: 'white',
											fontSize: '20px',
											fontWeight: 600,
											width: '100px',
											padding: 0,
											pointerEvents: 'auto',
										}}
										value={formatNumber(bankrollValue || '')}
										onChange={(e) => {
											const inputValue = e.target.value;
											// Remove commas and other non-numeric characters (except decimal point)
											let value = inputValue.replace(/[^0-9.]/g, '');
											// Prevent multiple decimal points
											const parts = value.split('.');
											if (parts.length > 2) {
												value = parts[0] + '.' + parts.slice(1).join('');
											}
											setBankrollValue(value);
											
											// Also update parent component if setBankroll is available
											if (setBankroll && typeof setBankroll === 'function') {
												setBankroll(value);
											}
											
											// Save bankroll (debounced)
											const currentUserdb = JSON.parse(window.localStorage.getItem('userdb'));
											saveBankrollDebounced(value, currentUserdb?.email);
										}}
										onBlur={() => {
											setBankrollEditable(false);
											// Save immediately on blur (clear timeout and save now)
											if (bankrollSaveTimeoutRef.current) {
												clearTimeout(bankrollSaveTimeoutRef.current);
											}
											const currentUserdb = JSON.parse(window.localStorage.getItem('userdb'));
											const email = currentUserdb?.email;
											if (email && bankrollValue && !isNaN(parseFloat(bankrollValue))) {
												saveBankrollDebounced(bankrollValue, email);
												// Force immediate save by clearing timeout and calling directly
												setTimeout(async () => {
													try {
														const copy = JSON.parse(window.localStorage.getItem('userdb'));
														if (copy?.user_data) {
															for (const c of copy.user_data) {
																c.bankroll = bankrollValue;
															}
															window.localStorage.setItem('userdb', JSON.stringify(copy));
														}
														await saveBankroll(bankrollValue, email);
													} catch (e) {
														console.error('Error saving bankroll on blur:', e);
													}
												}, 0);
											}
										}}
										onKeyDown={(e) => {
											if (e.key === 'Enter') {
												e.target.blur();
											}
										}}
										ref={bankrollbuttonref}
										autoComplete="off"
									/>
								</Box>
							)}
							<Box className="flex flex-row pt-3 pb-3 link pl-2" sx={{ alignItems: 'center', cursor: 'pointer', mb: 2 }} onClick={() => window.open('/blog')}>
								<img src={youtubeicon} alt="youtube icon" />
								<Box className="ml-3" sx={{ color: '#b1b6c3' }}>Tutorials and Resources</Box>
								<Modal open={isVideoModalOpen} onClose={() => setIsVideoModalOpen(false)}>
									<Box sx={{ position: 'relative', justifySelf: 'center', border: '1px solid #23262F', borderRadius: '10px', backgroundColor: '#22262e', marginTop: '12vh', width: '80%', outline: 'none' }}>
										<Button onClick={() => setIsVideoModalOpen(false)} sx={{ position: 'absolute', top: 10, right: 10, background: 'transparent', border: 'none', color: 'white', fontSize: '1.5rem', cursor: 'pointer' }} aria-label="Close">&times;</Button>
										<Box sx={{ textAlign: 'center', padding: 2, marginRight: 2, marginLeft: 2, marginTop: 2 }}>
											{/* Embed VimeoEmbed here if needed */}
										</Box>
									</Box>
								</Modal>
							</Box>
							<Box className="flex flex-row pt-3 pb-3 link pl-2" sx={{ alignItems: 'center', cursor: 'pointer', mb: 2 }} onClick={() => window.open('https://t.co/Z41E3czDHW')}>
								<img src={discordicongrey} alt="discord icon" />
								<Box className="ml-3" sx={{ color: '#b1b6c3' }}>Discord Community</Box>
							</Box>
							{plan !== 'Free' && (
								<Box className="flex flex-row pt-3 pb-3 link pl-2" sx={{ alignItems: 'center', cursor: isAccountLoading ? 'wait' : 'pointer', mb: 2, opacity: isAccountLoading ? 0.6 : 1 }} onClick={handleAccountSettingsClick}>
									<img src={settingsicon} alt="account icon" />
									<Box className="ml-3" sx={{ color: '#b1b6c3' }}>Account Settings</Box>
								</Box>
							)}
							<Box className="flex flex-row mb-4 pt-3 pb-3 link pl-2" sx={{ alignItems: 'center', cursor: 'pointer' }} onClick={() => { logout({ logoutParams: { returnTo: window.location.origin } }); window.localStorage.removeItem('userdb'); window.location.reload(); }}>
								<img src={logouticon} alt="logout icon" />
								<Box className="ml-3" sx={{ color: '#b1b6c3' }}>Log Out</Box>
							</Box>
						</Box>
					)}
				</Box>
			</Drawer>
		</>
	);
};
